import React from 'react';
import { Button } from 'react-bootstrap';
import moment from 'moment';

const SessionListItem = (props) => {
  const { session, sessionClose } = props;

  return (
    <ul className="login-operation-list-item">
      <li>
        <h4 className="platform">
          {session.platform}
        </h4>
        <span className="agent">
Cihaz:
          {' '}
        </span>
        <span className="agent-value">
          {
              session.device === 'computer'
                ? 'Bilgisayar'
                : session.device === 'mobile'
                  ? 'Telefon'
                  : session.device === 'tablet' ? 'Tablet' : 'Bilinmiyor'
          }
        </span>
      </li>
      <li>
        <span className="agent">
İşletim sistemi:
          {' '}
        </span>
        <span className="agent-value">
          {session.os}
        </span>
      </li>
      <li>
        <span className="agent">
Tarayıcı:
          {' '}
        </span>
        <span className="agent-value">
          {session.browser}
        </span>
      </li>
      <li>
        <span className="agent">
Giriş tarihi:
          {' '}
        </span>
        <span className="agent-value">
          {moment(new Date(session.date)).format('LLLL')}
        </span>
      </li>
      <li style={{ margin: '10px 0px 10px 0px' }}>
        <Button
          bsStyle="danger"
          onClick={() => {
            sessionClose(session);
          }}
          className="session-close-btn"
          style={{
            width: 'auto',
            padding: '10px',
            borderRadius: '5px',
            fontSize: '12px',
          }}
        >
                    Oturumu sonlandır
        </Button>
      </li>
    </ul>
  );
};
export default SessionListItem;



// WEBPACK FOOTER //
// ./src/components/session/list-item/index.js